import {ENDPOINTS} from 'constants/endpoints';

import {apiConfig} from 'libs/api/api';

import {logWithSentry} from 'libs/sentry/sentry';

import {SaveSubscriptionType} from '../types';

/**
 * Save subscription consent
 * @param {string} type - Type of subscription consent to save
 */
export const saveSubscriptionConsent = async (type: SaveSubscriptionType) => {
    try {
        await apiConfig.instanceGusaBackend({
            data: {type},
            method: 'post',
            url: ENDPOINTS.SUBSCRIPTION_CONSENT_SAVE,
        });
    } catch (error) {
        logWithSentry(error);
    }
};
